import Grid from '@material-ui/core/Grid';
import MuiPickersUtilsProvider from 'material-ui-pickers/MuiPickersUtilsProvider';
import MomentUtils from '@date-io/moment';
import InlineDatePicker from 'material-ui-pickers/DatePicker';
import React, {useState} from 'react';

const today = new Date();
today.setHours(0, 0, 0, 0);

const tonight = new Date();
tonight.setHours(23, 59, 59, 999);

const timeranges = {
  today: { start: 0, end: 0, title: 'Today' },
  yesterday: { start: 1, end: 1, title: 'Yesterday' },
  week: { start: 6, end: 0, title: 'Last 7 days' },
  month: { start: 29, end: 0, title: 'Last 30 days' }
};

const EventsAndMetricsDatepicker = (props) => {
  const [active, setActive] = useState('today');
  const [toDateValue, setToDateValue] = useState(tonight);
  const [fromDateValue, setFromDateValue] = useState(today);

  const byDateFilter = () => (
    <Grid item>
      <span>Filter by date</span>
      <ul className="unstyled link-list horizontal">
        {
          Object.entries(timeranges).map(([key, range]) => (
            <li key={`filter-by-${key}`}>
              <a className={active === key ? 'active' : ''} onClick={() => setRange(range.start, range.end, key)}>
                {range.title}
              </a>
            </li>
          ))
        }
      </ul>
    </Grid>
  );

  const datePickerProvider = () => {
    const data = [{label: 'From', value: fromDateValue}, {label: 'To', value: toDateValue}];
    return (
      <MuiPickersUtilsProvider utils={MomentUtils} className="margin-left margin-right inline-block">
        {data.map(item => inlineDatePicker(item))}
      </MuiPickersUtilsProvider>
    );
  };

  const inlineDatePicker = (item) => (
    <Grid item>
      <InlineDatePicker
        disabled={true}
        label={item.label}
        value={item.value}
        onChange={() => {}}
        className="margin-right"
        style={{ width: '160px', marginTop: 0, color: 'black' }}
      />
    </Grid>
  );

  function setRange(after, before, active) {
    filterBy(after, before);
    setActive(active);
  }

  function filterBy(after, before) {
    const startDate = new Date(), endDate = new Date();
    startDate.setDate(startDate.getDate() - (after || 0));
    startDate.setHours(0, 0, 0, 0);
    endDate.setDate(endDate.getDate() - (before || 0));
    endDate.setHours(23, 59, 59, 999);
    setFromDateValue(startDate);
    setToDateValue(endDate);
    props.filter(active, startDate, endDate);
  }

  return (
    <Grid
      container
      spacing={16}
      className="datepicker-container"
      style={{ paddingTop: 10, paddingBottom: 20, marginBottom: 20 }}>
      {byDateFilter()}
      {datePickerProvider()}
    </Grid>
  );
}

export default React.memo(EventsAndMetricsDatepicker);
